import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useFusionAuth from '../../shared/hooks/AptiveAuth/useFusionAuth';
import LoadingSpinner from '../../components/LoadingSpinner';
import { AuthType } from '../../constants/auth';

export default function RedirectPage() {
  const navigate = useNavigate();
  const { getAccessToken } = useFusionAuth();

  useEffect(() => {
    if (localStorage.getItem('authType') !== AuthType.FusionAuth) {
      navigate('/');
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state') || urlParams.get('userState');

    if (code && state) {
      getAccessToken(
        { code },
        {
          onSuccess: () => {
            navigate('/dashboard');
          },
          onError: () => {
            navigate('/logout');
          },
        }
      );
    } else {
      navigate('/');
    }
  }, [navigate]);

  return <LoadingSpinner centered />;
}
